import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: "",
  list: [],
  byId: {},
};

const ProjectsSlice = createSlice({
  name: "Projects",
  initialState,
  reducers: {
    recieveProjects(state, action) {
      state.list = action.payload
      state.byId = Object.fromEntries(action.payload.map(p => [p.id, p]));
    },
  },
});

export const {
  recieveProjects
} = ProjectsSlice.actions

export default ProjectsSlice.reducer;
